{
  "startNew": "Empezar de nuevo",
  "table": {
    "createdAt": "Se ejecutó en",
    "createdBy": "Ejecutado por",
    "state": "Estado",
    "organization": "Organización"
  },
  "fileTable": {
    "order": "Orden",
    "createdAt": "Cargado en",
    "name": "Nombre",
    "type": "Tipo de importación",
    "totalLineItems": "# Líneas",
    "queuedLineItems": "# En cola",
    "failedLineItems": "# Falló",
    "processedLineItems": "# Procesado",
    "state": "Estado",
    "actions": "Acciones",
    "menu": {
      "delete": "Eliminar",
      "process": "Proceso"
    }
  },
  "resumeProcessButton": "Reanudar",
  "processBulkImportMessage": "Se está procesando la importación por lotes.",
  "deleteFileMessage": "El archivo ha sido eliminado.",
  "resumeFileConfirmationDialog": {
    "title": "Reanudar el procesamiento del archivo",
    "text": "¿Está seguro de que desea reanudar el procesamiento del archivo?"
  },
  "deleteFileConfirmationDialog": {
    "title": "Eliminar archivo",
    "text": "¿Está seguro de que desea eliminar el archivo?"
  },
  "lineItemTable": {
    "externalId": "ID de línea de pedido",
    "oneVestId": "ID de OneVest",
    "state": "Estado"
  },
  "fileTypes": {
    "USER": "Clientes",
    "GOAL": "Metas",
    "ACCOUNT": "Cuentas",
    "ACCOUNT_AFFILIATE": "Afiliados de cuenta",
    "TRANSACTION": "Transacciones",
    "SECURITY_PRICE": "Precios históricos de seguridad",
    "PRODUCT_SHELF": "Estante de productos",
    "FOREIGN_EXCHANGE_RATE": "Tipos de cambio de divisas",
    "PORTFOLIO_SECURITIES": "Valores de Cartera"
  },
  "states": {
    "INITIATED": "INICIADO",
    "PROCESSING": "PROCESANDO",
    "FAILED": "FALLÓ",
    "CANCELED": "CANCELADO",
    "COMPLETED": "COMPLETADO",
    "QUEUED": "EN COLA",
    "PARTIALLY_FAILED": "FALLO PARCIAL",
    "PROCESSED": "PROCESADO"
  },
  "lineItemModal": {
    "errorTitle": "Errores",
    "errorCode": "Código",
    "errorField": "Campo",
    "errorDescription": "Descripción",
    "save": "Guardar",
    "addBackToQueue": "Agregar artículo a la lista de espera",
    "title": "Detalles del Artículo de Línea"
  },
  "addFile": "Agregar archivo",
  "addFileModal": {
    "title": "Agregar archivo de importación",
    "type": "Tipo de importación",
    "downloadTemplateButton": "Descargar plantilla",
    "button": "Cargar"
  },
  "bulkImportOn": "Importado en",
  "notSureHowToFormat": "¿No está seguro de cómo dar formato a su CSV? Utilice el nuestro",
  "template": "plantillas",
  "copyAndPaste": "Copiar y pegar valores",
  "errorFetchingTemplate": "Error al obtener la plantilla: {{error}}",
  "downloadTemplate": "Descargar plantilla",
  "importCsvFile": "Importar archivo CSV",
  "pasteDescription": "Importe un archivo CSV para agregar rápidamente valores a su cartera. Asegúrese de que su CSV incluya las siguientes columnas: Security Identifier (Ticker), Porcentaje de ponderación objetivo, Tax Rank (optional).",
  "pasteCsv": "Pegar CSV",
  "pastePlaceholder": "",
  "errors": {
    "emptyPaste": "Por favor, pegue el contenido del archivo CSV",
    "invalidContent": "Contenido CSV no válido: {{error}}",
    "processFailed": "No se pudo procesar el contenido pegado",
    "unknownError": "Error desconocido"
  },
  "success": {
    "imported": "{{fileName}} importado correctamente",
    "uploaded": "Documento subido correctamente: {{fileName}}"
  }
}
